/* eslint-disable @typescript-eslint/no-explicit-any */
export function handlePropCustomFunc(
  propOnClickFunc: any,
  event?: Event | InputEvent | MouseEvent,
  customArgs?: unknown[],
): void {
  if (propOnClickFunc === null || propOnClickFunc === undefined) return;

  if (typeof propOnClickFunc === 'string') {
    //TODO: Ajustar o atual comportamento de imprimir as aspas das strings
    //TODO: Ajustar o atual comportamento de quando passado parÂmetro contendo vírgula em strings, o dado é cortado até a vírgula
    const funcName = propOnClickFunc.split('(')[0] || propOnClickFunc;
    const params = propOnClickFunc.includes('(')
      ? propOnClickFunc.split('(')[1].replace(')', '').split(', ')
      : [];
    const args = params.map((param) => param.trim());

    window[funcName as keyof typeof window].apply(null, [
      ...args,
      ...(customArgs || []),
      event,
    ]);
    return;
  }

  propOnClickFunc(event);
}
